import React, { useState } from 'react';
import { BarChart, Bar, Cell,Area, AreaChart, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { isSameDay, addDays, subDays } from 'date-fns';
import "../../../styles/MainMenu.css"
import Dashboard from './DashBoardPage';
import SettingsView from './SettingsPage';
import ChangePasswordPage from './ChangePasswordPage';
import { useAuth } from '../context/AuthContext';
import ChangeEmailPage from './ChangeEmailPage';
import VerificationCodePage from './ValidationPage';

const MainMenu = ({currentView}) => {

  const {stepOneForgotPassword,mfaForgotPass,changeEmailVar,changeEmailMFAVar} = useAuth();

  const renderView = () => {
    console.log('currentView:', currentView)
    switch (currentView) {
      case 'dashboard':
        return (
          <Dashboard/>
        );
      
      case 'teams':
        return (
          <div className="page-view">
            <h1>Gestión de Equipos</h1>
            <p>Contenido de equipos...</p>
          </div>
        );
      
      case 'inventory':
          return null;    
      case 'settings':
          if(changeEmailVar)
          {
            if(changeEmailVar && changeEmailMFAVar){
              return <VerificationCodePage type='mail'/>
            }else
            {
              return <ChangeEmailPage/>
            }
          }
          else if(stepOneForgotPassword && mfaForgotPass)
          {
            return <ChangePasswordPage requireOldPassword={true}/>
          }
          else{
            return <SettingsView
              onPasswordChange={() => {}}
              onEmailChange={() => {}}
            />
          } 
      default:
        return null;
    }
  };

  return (
    <div className="main-menu">
      {/* Contenido principal */}
      <main className="main-content">
        {renderView()}
      </main>
    </div>
  );
};

export default MainMenu;